export const INVITE_USERS_START = "INVITE_USERS_START";
export const FETCH_USERS_LIST_START = "FETCH_USERS_LIST_START";
export const FETCH_USERS_LIST_SUCCESS = "FETCH_USERS_LIST_SUCCESS";
export const RESEND_INVITATION_START = "RESEND_INVITATION_START";
export const RESEND_INVITATION_SUCCESS = "RESEND_INVITATION_SUCCESS";
export const RESEND_INVITATION_FAILED = "RESEND_INVITATION_FAILED";
export const RESET_INVITATION_ACCOUNT_STATUS =
  "RESET_INVITATION_ACCOUNT_STATUS";
export const INVITE_USERS_FAILURE = "INVITE_USERS_FAILURE";
export const INVITE_USERS_SUCCESS = "INVITE_USERS_SUCCESS";
export const DELETE_SUBUSER_START = "DELETE_SUBUSER_START";
export const DELETE_SUBUSER_SUCCESS = "DELETE_SUBUSER_SUCCESS";
export const DELETE_SUBUSER_FAILED = "DELETE_SUBUSER_FAILED";
export const CANCEL_SUBUSER_INVITE_START = "CANCEL_SUBUSER_INVITE_START";
export const COPY_TO_CLIPBOARD = "COPY_TO_CLIPBOARD";
